import React from 'react'


const Header = (props) => (
	<header>
		 		<a href="/" className="navbar-brand">SHIKAI <span>Front-End Developer</span></a>
				<div className="navbar-toggle">    
				<label id="btn2" className="hamburger"  onClick = { props._handleClick } >
				      <hr className="bar"></hr>
				      <hr className="bar"></hr>
				      <hr className="bar"></hr>
		    	</label>
		    	</div>
	</header>
)
export default Header


// WEBPACK FOOTER //
// ./src/components/header.js